"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContractListStoresResponseSchema = exports.AdminContractGetStoreResponseSchema = exports.AdminContractStoreIdPathParamsSchema = exports.AdminContractListStoresQueryParamsSchema = exports.AdminContractUpdateStoreRequestSchema = exports.AdminContractCreateStoreRequestSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const schema_builder_1 = require("../../../shared/schema-builder");
const StoreSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    slug: zod_1.z.string(),
    image: zod_1.z.string(),
    openingHours: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    contactNumber: zod_1.z.string(),
    googleMapLink: zod_1.z.string(),
    name_en: zod_1.z.string(),
    name_th: zod_1.z.string(),
    address_en: zod_1.z.string(),
    address_th: zod_1.z.string(),
});
const ProductSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    collectionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    restockedAt: zod_1.z.coerce.date().nullable(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    skuNo: zod_1.z.string(),
    coverImage: zod_1.z.string(),
    images: zod_1.z.string().array(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    price: zod_1.z.number(),
    priceUsd: zod_1.z.number(),
    stock: zod_1.z.number().int(),
    isAvailable: zod_1.z.boolean(),
    frameShape: zod_1.z.string().nullable(),
    frameColor: zod_1.z.string().nullable(),
    lensColor: zod_1.z.string().nullable(),
    isPolarized: zod_1.z.boolean(),
});
const ProductDiscountSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    startDate: zod_1.z.coerce.date(),
    endDate: zod_1.z.coerce.date(),
    discountPrice: zod_1.z.number(),
    discountPriceUsd: zod_1.z.number(),
    productId: zod_1.z.string(),
});
exports.AdminContractCreateStoreRequestSchema = StoreSchema.pick({
    image: true,
    name_en: true,
    name_th: true,
    address_en: true,
    address_th: true,
    openingHours: true,
    contactNumber: true,
    googleMapLink: true,
}).extend({ productIds: zod_1.z.string().array().default([]) });
exports.AdminContractUpdateStoreRequestSchema = exports.AdminContractCreateStoreRequestSchema;
exports.AdminContractListStoresQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({
    search_en: zod_1.z.string().optional(),
    search_th: zod_1.z.string().optional(),
    sortBy: zod_1.z.string().default('createdAt|desc'),
});
exports.AdminContractStoreIdPathParamsSchema = zod_1.z.object({ storeId: zod_1.z.string() });
const StoreProductSchema = new schema_builder_1.SchemaBuilder(ProductSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('deletedAt', zod_1.z.string().datetime().nullable())
    .replaceDateField('restockedAt', zod_1.z.string().datetime().nullable())
    .extend({
    collectionName: zod_1.z.string(),
    collectionSlug: zod_1.z.string(),
    discount: new schema_builder_1.SchemaBuilder(ProductDiscountSchema)
        .replaceDateField('startDate')
        .replaceDateField('endDate')
        .build().nullable(),
}).build();
const AdminContractStoreWithProductSchema = StoreSchema.omit({
    createdAt: true,
    updatedAt: true,
}).extend({
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    products: StoreProductSchema.array(),
});
exports.AdminContractGetStoreResponseSchema = zod_1.z.object({ store: AdminContractStoreWithProductSchema });
exports.AdminContractListStoresResponseSchema = shared_1.ContractBaseListResponseSchema.extend({
    stores: StoreSchema.omit({
        createdAt: true,
        updatedAt: true,
    }).extend({
        createdAt: zod_1.z.string(),
        updatedAt: zod_1.z.string(),
    }).array(),
});
